import { render, staticRenderFns } from "./IconBarChart2.vue?vue&type=template&id=0f0dcbe8&"
import script from "./IconBarChart2.vue?vue&type=script&lang=ts&"
export * from "./IconBarChart2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports